var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('settings-toolbar',{attrs:{"title":"Company Settings"}}),_c('invoice-settings'),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('tax-settings')],1),_c('div',{staticClass:"col-lg-6"},[_c('company-addresses')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }